import React, { useEffect, useRef, useState } from 'react';
import './ConfirmModal.scss';
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import ReactDOM from "react-dom";


function ConfirmModal({ message, onConfirm, onCancel, key, customContentWidth, confirmText, cancelText, loadingText}) {
  const [showLoader, setShowLoader] = useState(true);
  // True while an async onConfirm is in flight — disables both buttons and
  // shows a spinner. The ref guards against double-clicks landing before the
  // state update re-renders the disabled button.
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false);
  const mountedRef = useRef(true);

  useEffect(() => () => { mountedRef.current = false; }, []);

  // Function to handle the confirm action
  async function handleConfirm() {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setIsSubmitting(true);
    document.body.classList.remove('glloading');
    setShowLoader(false);
    try {
      await onConfirm(key); // Assuming onConfirm can handle being called with 'key'
    } finally {
      // Parents usually unmount the modal once the action settles; only reset
      // if it is still on screen (e.g. validation kept it open).
      submittingRef.current = false;
      if (mountedRef.current) setIsSubmitting(false);
    }
  }

  // Function to handle the cancel action
  function handleCancel() {
    if (submittingRef.current) return;
    setShowLoader(false);
    document.body.classList.remove('glloading');
    onCancel();
  }

  // useEffect hook to manage the loading class on the body element
  useEffect(() => {
    if (showLoader) {
      document.body.classList.add('glloading');
    } else {
      document.body.classList.remove('glloading');
    }
  }, [showLoader]); // Dependency array includes only showLoader

  return ReactDOM.createPortal(
    <div className="confirm-modal">
      <div className="confirm-modal-content">
        <div className="confirm-modal-message">{message}</div>
        <div className="form_popup_button_row_modal">
          <div className="form_button_element button_padding">
            <DefaultButton
              className="form_popup_btn_cancel-builder"
              text={cancelText || 'Cancel'}
              onClick={handleCancel}
              disabled={isSubmitting}
            />
          </div>
          <div className="form_btn_margin_right">
            <PrimaryButton
              className="form_popup_btn_margin-builder"
              text={isSubmitting ? (loadingText || `${confirmText || 'Confirm'}...`) : (confirmText || 'Confirm')}
              onClick={handleConfirm}
              disabled={isSubmitting}
              aria-busy={isSubmitting}>
              {isSubmitting && <i className="fa fa-refresh fa-spin confirm-modal-spinner" />}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ConfirmModal;
